import type { z } from 'zod';
import { ApiError } from './api/errors';

/** Mensagem por campo (chave = nome do campo). */
export type FieldErrors = Record<string, string | undefined>;

/** Primeira mensagem de cada campo de um erro de validação do app (mesmos schemas da API). */
export function zodFieldErrors(error: z.ZodError): FieldErrors {
  const out: FieldErrors = {};
  for (const issue of error.issues) {
    const field = String(issue.path[0] ?? '');
    if (field && !out[field]) out[field] = issue.message;
  }
  return out;
}

/** Mensagens por campo vindas da API (validação no servidor ou regra de negócio com `details`). */
export function apiFieldErrors(err: unknown): FieldErrors {
  if (!(err instanceof ApiError)) return {};
  const out: FieldErrors = {};
  for (const d of err.details) {
    const field = d.path.split('.')[0];
    if (field && !out[field]) out[field] = d.message;
  }
  return out;
}

/** Algum campo com erro? */
export const hasFieldErrors = (errors: FieldErrors) => Object.values(errors).some(Boolean);
